import { render, staticRenderFns } from "./itens.vue?vue&type=template&id=29e35fd6"
import script from "./itens.vue?vue&type=script&lang=js"
export * from "./itens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports